import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function SEOServices() {
  return (
    <div className="pt-16">
      <Helmet>
        <title>Best SEO Company in Chhindwara | Top SEO Services India | Zolo Service</title>
        <meta name="description" content="Professional SEO services in Chhindwara. Boost your website rankings with our expert SEO strategies. Local SEO specialists for businesses across India." />
        <meta name="keywords" content="SEO company Chhindwara, best SEO services Chhindwara, local SEO Chhindwara, SEO expert Chhindwara, SEO packages Chhindwara, best SEO company in India, affordable SEO services India" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Service",
              "serviceType": "SEO Services",
              "provider": {
                "@type": "LocalBusiness",
                "name": "Zolo Service",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Chhindwara",
                  "addressRegion": "Madhya Pradesh",
                  "postalCode": "480001",
                  "addressCountry": "India"
                },
                "telephone": "+91-9993547121",
                "priceRange": "₹₹"
              },
              "areaServed": ["Chhindwara", "Madhya Pradesh", "India"],
              "description": "Boost your website's visibility and drive organic traffic with our expert SEO strategies in Chhindwara and across India.",
              "offers": {
                "@type": "Offer",
                "priceSpecification": {
                  "@type": "PriceSpecification",
                  "priceCurrency": "INR"
                }
              }
            }
          `}
        </script>
      </Helmet>
      
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/services/seo-detail.jpg')` }}
          aria-hidden="true"
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Best SEO Services in Chhindwara</h1>
            <p className="text-xl mb-8">
              Boost your website's visibility and drive organic traffic with our expert SEO strategies in Chhindwara and across India.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-zolo-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold mb-6">Improve Your Search Engine Rankings with Chhindwara's Top SEO Company</h2>
            
            <p className="text-lg text-gray-700 mb-6">
              At Zolo Service, we help businesses in Chhindwara and across India improve their online visibility through comprehensive SEO strategies. Our data-driven approach ensures your website ranks higher in search results, driving more targeted traffic and increasing conversions for your local business.
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Professional SEO Services Include:</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">On-Page SEO Optimization</h4>
                  <p className="text-gray-700">
                    Optimization of website content, meta tags, headings, and internal linking structure for better search rankings.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Off-Page SEO Strategy</h4>
                  <p className="text-gray-700">
                    Building high-quality backlinks and improving your website's authority and reputation in Chhindwara and beyond.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Technical SEO Improvements</h4>
                  <p className="text-gray-700">
                    Improving website speed, mobile-friendliness, site structure, and fixing technical issues for better performance.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Local SEO for Chhindwara Businesses</h4>
                  <p className="text-gray-700">
                    Enhancing your visibility in local search results to attract nearby customers in Chhindwara and surrounding areas.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Comprehensive Keyword Research</h4>
                  <p className="text-gray-700">
                    Identifying the most relevant and valuable keywords for your business and industry in both local and national markets.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">SEO Content Optimization</h4>
                  <p className="text-gray-700">
                    Creating and optimizing SEO-friendly content that engages users and ranks well in search engines for targeted keywords.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Proven SEO Process</h3>
              
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    1
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Comprehensive SEO Audit</h4>
                    <p className="text-gray-700">We analyze your current website performance, identify issues, and assess opportunities for improvement.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    2
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Strategic Keyword Research</h4>
                    <p className="text-gray-700">We research and identify the most valuable keywords for your business in Chhindwara and across India.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    3
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">On-Page SEO Optimization</h4>
                    <p className="text-gray-700">We optimize your website content, meta tags, headings, and internal linking structure for better rankings.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    4
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Technical SEO Improvements</h4>
                    <p className="text-gray-700">We fix technical issues and improve site speed, mobile-friendliness, and structure for optimal performance.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    5
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Off-Page SEO Strategy</h4>
                    <p className="text-gray-700">We build quality backlinks and improve your website's authority and reputation in search engines.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4" aria-hidden="true">
                    6
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">SEO Monitoring & Reporting</h4>
                    <p className="text-gray-700">We track your rankings, traffic, and conversions, providing regular detailed performance reports.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12">
              <h3 className="text-2xl font-bold mb-4">Why Choose Our SEO Services in Chhindwara?</h3>
              
              <ul className="space-y-4 text-lg text-gray-700">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Data-Driven SEO Approach:</strong> We base our strategies on thorough research and analytics for measurable results.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>White Hat SEO Techniques:</strong> We use only ethical SEO practices that comply with search engine guidelines for sustainable results.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Transparent SEO Reporting:</strong> We provide clear, detailed reports on your SEO performance and progress.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Local SEO Expertise:</strong> We understand the Chhindwara market and can optimize for local searches to attract nearby customers.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Continuous SEO Improvement:</strong> We constantly refine our strategies based on results and algorithm updates for optimal performance.</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-24">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Ready to Rank Higher in Chhindwara?</h3>
                <p className="mb-0">Contact us today for a free SEO audit and consultation.</p>
              </div>
              
              <div className="p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Name"
                      aria-label="Your Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Email"
                      aria-label="Your Email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Phone</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Phone"
                      aria-label="Your Phone"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Website URL</label>
                    <input 
                      type="url" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Website URL"
                      aria-label="Your Website URL"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message</label>
                    <textarea 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={4}
                      placeholder="Tell us about your SEO goals"
                      aria-label="Your Message"
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300"
                  >
                    Get a Free SEO Audit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
